export default "__VITE_ASSET__BS$pRYiD__"